import { fehlertext } from '../../api/client'
import { rueckfrage } from '../../components/Rueckfrage'
import { useDatenbankAufraeumen, useDatenbankVorschau, useMe } from '../../hooks/queries'
import { useTexte } from '../../texte'

/**
 * Sweeping the rows the application no longer needs (#82, 1.10.0).
 *
 * Preview first, button second: the card counts per table what would go,
 * and the button asks once more with the total. The rules live on the
 * server (`DatabaseCleanup`); this card only names the tables.
 */
export function DatenbankCard() {
  const texte = useTexte()
  const t = texte.betrieb
  const me = useMe()
  const vorschau = useDatenbankVorschau(me.data?.may_operate === true)
  const raeumen = useDatenbankAufraeumen()

  if (vorschau.isPending) return <p className="card__lead leise">…</p>
  if (vorschau.isError) {
    return (
      <p className="notice" role="alert">
        {fehlertext(vorschau.error)}
      </p>
    )
  }
  const daten = vorschau.data

  return (
    <div className="card card--seite" data-datenbank="">
      <p className="card__lead">{t.datenbankLead}</p>

      {Object.entries(daten.stale).map(([tabelle, zahl]) => (
        <p className="dienst" key={tabelle} data-tabelle={tabelle} data-zahl={zahl}>
          <span className="dienst__name">{t.datenbankTabelle[tabelle] ?? tabelle}</span>
          <span className="dienst__zeilen">{t.datenbankZeilen(zahl)}</span>
        </p>
      ))}

      {raeumen.isError && (
        <p className="notice" role="alert">
          {fehlertext(raeumen.error)}
        </p>
      )}
      {raeumen.isSuccess && !raeumen.isPending && (
        <p className="platz__zahl platz__zahl--abstand" data-datenbank-ergebnis={raeumen.data.total}>
          {t.datenbankWeggeraeumt(raeumen.data.total)}
        </p>
      )}

      {daten.total === 0 ? (
        <p className="leise" data-datenbank-leer="">{t.datenbankNichts}</p>
      ) : (
        <button
          type="button"
          className="button button--outline"
          style={{ width: 'auto', marginTop: 12 }}
          disabled={raeumen.isPending}
          data-datenbank-knopf=""
          onClick={async () => {
            if (await rueckfrage(t.datenbankFrage(daten.total), t.datenbankAufraeumenKurz)) {
              raeumen.mutate()
            }
          }}
        >
          {t.datenbankAufraeumen}
        </button>
      )}
    </div>
  )
}
